export default {
    clientOnline: true,
    UILang: 'en',
    cookiesPolicy: {
        exp: new Date(),
        accepted: false
    },
    introductionSeen: false,
    clientBuildDate: process.env.REACT_APP_BUILDDATE,
    clientStatusMessages: [],
    user: {
        authenticated: false,
        data: {
            ID: null,
            firstName: 'Jon',
            lastName: 'Doe',
            email: null,
            UIRoles: {
                DIH: true,
                SA: true
            },
            UILang: 'en'
        },
        JWT: {
            original: {},
            decoded: {
                access: {},
                refresh: {}
            }
        }
    }
}
